import { type LucideIcon } from "lucide-react"
import { motion } from "framer-motion"
import { Card } from "@/components/ui/card"

interface IconCardProps {
  icon: LucideIcon
  title: string
  description: string
  delay?: number
}

export function IconCard({ icon: Icon, title, description, delay = 0 }: IconCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3, delay }}
      className="h-full"
    >
      <Card variant="default" className="p-6 h-full">
        <div className="w-11 h-11 rounded-md bg-info-soft flex items-center justify-center mb-5">
          <Icon className="w-5 h-5 text-primary" />
        </div>
        <h3 className="text-heading-sm text-ink mb-2">{title}</h3>
        <p className="text-body text-ink-soft">{description}</p>
      </Card>
    </motion.div>
  )
}
